import { notEmptyString } from '@/contexts/shared/form-validation/FormValidationRules.helpers'

export const emailSchema = () => notEmptyString.email()
